/**
 * Church ID utility helpers
 * Detects empty/unassigned church IDs across all representations
 */

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

/**
 * Returns true if the churchId is null, undefined, empty string, or the empty GUID.
 * Use this to guard routes and API calls that require a valid church.
 */
export function isEmptyChurchId(churchId: string | null | undefined): boolean {
  if (!churchId) return true;
  return churchId.trim() === '' || churchId === EMPTY_GUID;
}
